import React, { useState } from 'react';

const API = 'https://api.botanix.in/api';

const C = {
 bg:'#0A1628', surface:'#0F2040', surface2:'#162A40',
 border:'rgba(30,58,95,.8)', border2:'rgba(30,58,95,1)',
 text:'#F0F2FF', text2:'#A0A8C0', text3:'#606880',
 accent:'#22C55E', red:'#EF4444', redBg:'rgba(239,68,68,.10)', redBorder:'rgba(239,68,68,.25)',
 amber:'#F59E0B',
};

const inp = { width:'100%', padding:'12px 14px', background:'rgba(255,255,255,.06)', border:`1px solid rgba(30,58,95,1)`, borderRadius:10, color:'#F0F2FF', fontSize:14, boxSizing:'border-box', outline:'none', fontFamily:'Inter,sans-serif', letterSpacing:'.02em' };

export default function ForgotPassword({ onBack }) {
 const [step, setStep] = useState(1); // 1=email, 2=otp, 3=new password, 4=success
 const [email, setEmail] = useState('');
 const [otp, setOtp] = useState('');
 const [newPass, setNewPass] = useState('');
 const [confirmPass, setConfirm] = useState('');
 const [loading, setLoading] = useState(false);
 const [error, setError] = useState('');
 const [showPass, setShowPass] = useState(false);

 const handleSendOTP = async () => {
 if (!email) { setError('Enter your email address'); return; }
 setLoading(true); setError('');
 try {
 const r = await fetch(`${API}/sessions/forgot-password`, {
 method:'POST', headers:{'Content-Type':'application/json'},
 body: JSON.stringify({ email }),
 });
 const d = await r.json();
 if (!r.ok) throw new Error(d.error||'Failed to send OTP');
 setStep(2);
 } catch(e) { setError(e.message); }
 finally { setLoading(false); }
 };

 const handleVerifyOTP = async () => {
 if (!otp || otp.length < 6) { setError('Enter the 6-digit OTP'); return; }
 setStep(3);
 setError('');
 };

 const handleResetPassword = async () => {
 if (!newPass) { setError('Enter new password'); return; }
 if (newPass.length < 6) { setError('Password must be at least 6 characters'); return; }
 if (newPass !== confirmPass) { setError('Passwords do not match'); return; }
 setLoading(true); setError('');
 try {
 const r = await fetch(`${API}/sessions/reset-password`, {
 method:'POST', headers:{'Content-Type':'application/json'},
 body: JSON.stringify({ email, otp, newPassword: newPass }),
 });
 const d = await r.json();
 if (!r.ok) throw new Error(d.error||'Reset failed');
 setStep(4);
 } catch(e) { setError(e.message); }
 finally { setLoading(false); }
 };

 const STEPS = ['Enter Email','Verify OTP','New Password','Done'];

 return (
 <div style={{ minHeight:'100vh', background:C.bg, display:'flex', alignItems:'center', justifyContent:'center', padding:16, fontFamily:'Inter,sans-serif' }}>
 <div style={{ width:'100%', maxWidth:420 }}>

 {/* Logo */}
 <div style={{ textAlign:'center', marginBottom:32 }}>
 <img src="https://botanix.in/wp-content/uploads/2025/12/Botanix-Nature-Resort-Logo.webp"
 alt="Botanix" style={{ height:64, objectFit:'contain', marginBottom:16 }}
 onError={e=>e.target.style.display='none'} />
 <div style={{ fontSize:22, fontWeight:900, color:'#F0F2FF' }}>Reset Password</div>
 <div style={{ fontSize:13, color:C.text2, marginTop:4 }}>Botanix Nature Resort ERP</div>
 </div>

 {/* Step indicators */}
 <div style={{ display:'flex', gap:6, marginBottom:28 }}>
 {STEPS.map((s,i)=>(
 <div key={i} style={{ flex:1, textAlign:'center' }}>
 <div style={{ width:28, height:28, borderRadius:'50%', background:step>i+1?C.accent:step===i+1?C.accent:'rgba(255,255,255,.1)', color:'#fff', display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, margin:'0 auto 4px' }}>
 {step>i+1?'':i+1}
 </div>
 <div style={{ fontSize:9, color:step===i+1?C.accent:C.text3 }}>{s}</div>
 </div>
 ))}
 </div>

 <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, padding:28 }}>

 {error && (
 <div style={{ padding:'10px 14px', background:C.redBg, border:`1px solid ${C.redBorder}`, borderRadius:8, color:C.red, fontSize:13, marginBottom:16 }}>
 {error}
 </div>
 )}

 {/* Step 1 — Email */}
 {step===1 && (
 <div>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:6 }}>Forgot your password?</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>Enter your registered email address. We'll send you a 6-digit OTP to reset your password.</div>
 <label style={{ display:'block', fontSize:11, color:C.text2, marginBottom:5, fontWeight:700, textTransform:'uppercase' }}>Email Address</label>
 <input style={{ ...inp, marginBottom:20 }} type="email" value={email}
 onChange={e=>setEmail(e.target.value)}
 onKeyDown={e=>e.key==='Enter'&&handleSendOTP()}
 placeholder="your@email.com" autoFocus />
 <button onClick={handleSendOTP} disabled={loading}
 style={{ width:'100%', padding:'13px', background:C.accent, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', opacity:loading?.6:1 }}>
 {loading?'Sending OTP…':'Send OTP →'}
 </button>
 </div>
 )}

 {/* Step 2 — OTP */}
 {step===2 && (
 <div>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:6 }}>Enter OTP</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:4 }}>A 6-digit OTP has been sent to:</div>
 <div style={{ fontSize:14, fontWeight:700, color:C.accent, marginBottom:20 }}>{email}</div>
 <div style={{ background:`${C.amber}10`, border:`1px solid ${C.amber}33`, borderRadius:8, padding:'10px 14px', marginBottom:16, fontSize:12, color:C.amber }}>
 OTP is valid for 30 minutes. Also check your Super Admin has been notified.
 </div>
 <label style={{ display:'block', fontSize:11, color:C.text2, marginBottom:5, fontWeight:700, textTransform:'uppercase' }}>6-Digit OTP</label>
 <input style={{ ...inp, fontSize:24, fontWeight:900, letterSpacing:12, textAlign:'center', marginBottom:20 }}
 type="text" maxLength={6} value={otp}
 onChange={e=>setOtp(e.target.value.replace(/\D/g,''))}
 onKeyDown={e=>e.key==='Enter'&&handleVerifyOTP()}
 placeholder="000000" autoFocus />
 <button onClick={handleVerifyOTP} disabled={loading||otp.length<6}
 style={{ width:'100%', padding:'13px', background:C.accent, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', opacity:(loading||otp.length<6)?.5:1 }}>
 Verify OTP →
 </button>
 <button onClick={()=>{setStep(1);setOtp('');}}
 style={{ width:'100%', marginTop:10, padding:'10px', background:'none', border:`1px solid ${C.border2}`, borderRadius:10, color:C.text2, cursor:'pointer', fontSize:13 }}>
 ← Use different email
 </button>
 </div>
 )}

 {/* Step 3 — New Password */}
 {step===3 && (
 <div>
 <div style={{ fontWeight:700, fontSize:16, color:C.text, marginBottom:6 }}>Set New Password</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:20 }}>Choose a strong password for your account.</div>
 <label style={{ display:'block', fontSize:11, color:C.text2, marginBottom:5, fontWeight:700, textTransform:'uppercase' }}>New Password</label>
 <div style={{ position:'relative', marginBottom:14 }}>
 <input style={{ ...inp }} type={showPass?'text':'password'} value={newPass}
 onChange={e=>setNewPass(e.target.value)} placeholder="Min. 6 characters" autoFocus />
 <button onClick={()=>setShowPass(p=>!p)}
 style={{ position:'absolute', right:10, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', color:C.text2, cursor:'pointer', fontSize:16 }}>
 {showPass?'':''}
 </button>
 </div>
 <label style={{ display:'block', fontSize:11, color:C.text2, marginBottom:5, fontWeight:700, textTransform:'uppercase' }}>Confirm Password</label>
 <input style={{ ...inp, marginBottom:20 }} type={showPass?'text':'password'} value={confirmPass}
 onChange={e=>setConfirm(e.target.value)}
 onKeyDown={e=>e.key==='Enter'&&handleResetPassword()}
 placeholder="Repeat new password" />
 {/* Password strength */}
 {newPass && (
 <div style={{ marginBottom:16 }}>
 <div style={{ display:'flex', gap:4, marginBottom:4 }}>
 {[...Array(4)].map((_,i)=>(
 <div key={i} style={{ flex:1, height:4, borderRadius:2, background:
 newPass.length>8&&/[A-Z]/.test(newPass)&&/[0-9]/.test(newPass)&&/[^A-Za-z0-9]/.test(newPass)?C.accent:
 newPass.length>6&&(/[A-Z]/.test(newPass)||/[0-9]/.test(newPass))?C.amber:
 i===0?C.red:'rgba(255,255,255,.1)' }} />
 ))}
 </div>
 <div style={{ fontSize:11, color:C.text3 }}>
 {newPass.length>8&&/[A-Z]/.test(newPass)&&/[0-9]/.test(newPass)?'Strong password ':
 newPass.length>6?'Medium — add numbers & uppercase':
 'Weak — too short'}
 </div>
 </div>
 )}
 <button onClick={handleResetPassword} disabled={loading}
 style={{ width:'100%', padding:'13px', background:C.accent, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer', opacity:loading?.6:1 }}>
 {loading?'Resetting…':'Reset Password '}
 </button>
 </div>
 )}

 {/* Step 4 — Success */}
 {step===4 && (
 <div style={{ textAlign:'center' }}>
 <div style={{ fontSize:56, marginBottom:16 }}></div>
 <div style={{ fontWeight:800, fontSize:20, color:C.accent, marginBottom:8 }}>Password Reset!</div>
 <div style={{ fontSize:13, color:C.text2, marginBottom:24 }}>Your password has been updated successfully. You can now log in with your new password.</div>
 <button onClick={onBack}
 style={{ width:'100%', padding:'13px', background:C.accent, border:'none', borderRadius:10, color:'#fff', fontSize:15, fontWeight:700, cursor:'pointer' }}>
 Back to Login →
 </button>
 </div>
 )}
 </div>

 {/* Back to login */}
 {step!==4 && (
 <button onClick={onBack}
 style={{ width:'100%', marginTop:14, padding:'10px', background:'none', border:'none', color:C.text2, cursor:'pointer', fontSize:13 }}>
 ← Back to Login
 </button>
 )}
 </div>
 </div>
 );
}
